import { render } from "./Verifications.vue?vue&type=template&id=1d3180f0&scoped=true"
import script from "./Verifications.vue?vue&type=script&lang=js"
export * from "./Verifications.vue?vue&type=script&lang=js"

import "./Verifications.vue?vue&type=style&index=0&id=1d3180f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3180f0"]])

export default __exports__